// extracted by mini-css-extract-plugin
module.exports = {"container":"AppliedTransactionTips_container_GRWqX","section":"AppliedTransactionTips_section_3l1pS"};